export const blockIconsHardwareHeadsetMicNew = (
	<span className='material-symbols-outlined'>headset_mic</span>
);
